import Entity from '../entity'

export default class Category extends Entity<number>{
    parent_id: number;
    name: string;
    description: string;
    level_depth: number;
    nleft: number;
    nright: number;
    active: boolean;
    position: number;
}


